import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { GymChainProgramAccessCategoryType } from '../../particles/types/GymChainProgramAccessCategory';
import { getGymChainProgramAccessCategories } from '../../graphql/queries';
import { GymChainProgramAccessCategories } from '../../API';
import { removeSiteAccessCategory } from '../../graphql/mutations';

const initialState: {
  isAccessCategoriesLoading: boolean;
  items: Array<{
    siteId: number;
    items: GymChainProgramAccessCategoryType[];
    totalRecords: number;
  }>;
} = {
  isAccessCategoriesLoading: false,
  items: []
};

type paramType = {
  siteId: number;
};

export const fetchGymChainProgramAccessCategory = createAsyncThunk(
  '/gym/gymChainProgramAccessCategory',
  async (params: paramType) => {
    console.log(params);
    const response = await (API.graphql({
      query: getGymChainProgramAccessCategories,
      variables: {
        siteId: params.siteId
      }
    }) as Promise<{
      data: {
        getGymChainProgramAccessCategories: {
          items: GymChainProgramAccessCategories[];
          totalRecords: { totalRecords: number };
        };
      };
    }>);
    console.log(response);
    return response;
  }
);

export const deleteGymChainProgramAccessCategory = createAsyncThunk(
  '/gym/deleteGymChainProgramAccessCategory',
  async (deleteAccessCategoryIds: number[]) => {
    const response = await API.graphql({
      query: removeSiteAccessCategory,
      variables: {
        ids: deleteAccessCategoryIds
      }
    });
    console.log(response);
    return response;
  }
);

export const gymChainProgramAccessCategoriesSlice = createSlice({
  name: 'GymChainProgramAccessCategory',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchGymChainProgramAccessCategory.fulfilled, (state, action) => {
      state.isAccessCategoriesLoading = false;
      if (!action.payload.data.getGymChainProgramAccessCategories?.items) {
        return;
      }

      const items = action.payload.data.getGymChainProgramAccessCategories.items.map(
        (e: GymChainProgramAccessCategories): GymChainProgramAccessCategoryType => {
          return {
            id: e.id || 0,
            siteId: e.siteId || 0,
            name: e.name || '',
            gender: e.gender || '',
            age: e.age || 0,
            schedulesOnly: e.schedulesOnly ? 'true' : 'false',
            status: e.status || '',
            programAccessCategoryId: e.programAccessCategoryId || 0,
            programId: e.programId || 0,
            accessCategoryId: e.accessCategoryId || 0,
            arxAccessCategoryId: e.arxAccessCategoryId || '',
            programImportedId: e.importedId || 0,
            programName: e.programName || '',
            scheduleType: e.scheduleType || ''
          };
        }
      );
      console.log({ items });

      const totalRecords =
        action.payload.data.getGymChainProgramAccessCategories.totalRecords.totalRecords;

      const fetchGymChainProgramAccessCategoryInfo = {
        totalRecords: totalRecords,
        items: items,
        siteId: action.meta.arg.siteId
      };

      if (state.items.length === 0) {
        state.items.push(fetchGymChainProgramAccessCategoryInfo);
      } else {
        const update = state.items.find(
          (gymChainAccessCategoryInfo) =>
            gymChainAccessCategoryInfo.siteId === fetchGymChainProgramAccessCategoryInfo.siteId
        );
        if (update) {
          const newState = state.items.map((accessCategoryInfo) => {
            if (accessCategoryInfo.siteId === fetchGymChainProgramAccessCategoryInfo.siteId) {
              return fetchGymChainProgramAccessCategoryInfo;
            } else {
              return accessCategoryInfo;
            }
          });
          state.items = newState;
        } else {
          state.items.push(fetchGymChainProgramAccessCategoryInfo);
        }
      }
    });

    builder.addCase(fetchGymChainProgramAccessCategory.pending, (state, action) => {
      state.isAccessCategoriesLoading = true;
      return state;
    });

    builder.addCase(fetchGymChainProgramAccessCategory.rejected, (state, action) => {
      state.isAccessCategoriesLoading = false;
      console.log('Fetch access categories error');
      return state;
    });

    builder.addCase(deleteGymChainProgramAccessCategory.fulfilled, (state, action) => {
      state.isAccessCategoriesLoading = false;
      const accessCategoryId = action.meta.arg;
      const filtered = state.items.map((accessCategoryObj) => {
        const filteredAccessCategories = accessCategoryObj.items.filter(
          (accessCategory) => !accessCategoryId.includes(accessCategory.id)
        );
        accessCategoryObj.items = filteredAccessCategories;
        accessCategoryObj.totalRecords = accessCategoryObj.totalRecords - 1;
        return accessCategoryObj;
      });
      state.items = filtered;
    });

    builder.addCase(deleteGymChainProgramAccessCategory.pending, (state, action) => {
      state.isAccessCategoriesLoading = true;
      return state;
    });

    builder.addCase(deleteGymChainProgramAccessCategory.rejected, (state, action) => {
      state.isAccessCategoriesLoading = false;
      console.error('deleteAccessCategory', action);
      return state;
    });
  }
});

export default gymChainProgramAccessCategoriesSlice.reducer;
